import React from 'react'
import { Menu } from 'util/ui'

import BusinessHoursControl from '../BusinessHoursControl'
import DateControl from '../DateControl'
import styles from './styles.less'

export default function ControlBar({ prerenderDatePicker }) {
  return (
    <Menu fixed="top" className={styles.ControlBar}>
      <Menu.Menu position="left">
        <Menu.Item fitted>
          <BusinessHoursControl />
        </Menu.Item>
      </Menu.Menu>
      <Menu.Menu position="right">
        <Menu.Item fitted>
          <DateControl prerender={prerenderDatePicker} />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}
